// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-award-container{grid-area:aw}.bw-button-grid{display:grid;grid-template-columns:1fr 1fr;grid-gap:.8rem}.bw-button-grid button{grid-row:1}.bw-button-grid .bw-login-button{grid-column:2}@media only screen and (max-width: 599px){.bw-button-grid .bw-login-button{grid-column:1/-1}.bw-button-grid .bw-join-button{grid-row:2;grid-column:1/-1}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"award-container": "bw-award-container",
	"button-grid": "bw-button-grid",
	"login-button": "bw-login-button",
	"join-button": "bw-join-button"
};
module.exports = ___CSS_LOADER_EXPORT___;
